import React, { useState } from 'react';
import './Modal.css';

const TramiteRequestDeletionModal = ({ isOpen, tramite, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      alert('Por favor, ingrese un motivo para la eliminación.');
      return;
    }
    setSubmitting(true);
    try {
      await onConfirm(reason);
      setReason('');
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !submitting && onClose()}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🗑️ Solicitar Eliminación</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p>Se enviará una solicitud al Tránsito para eliminar este trámite. Por favor, indique el motivo:</p>
            {tramite && (
              <div className="cupl-preview" style={{ background: 'var(--secondary-soft, #f8fafc)', padding: '15px', borderRadius: '8px', margin: '15px 0', border: '1px solid var(--card-border, #e2e8f0)' }}>
                <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>ID:</span>
                  <span className="value" style={{ fontWeight: 'bold' }}>#{tramite.id}</span>
                </div>
                <div className="preview-item" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <span className="label" style={{ fontWeight: 'bold', color: 'var(--text-secondary, #64748b)' }}>Placa:</span>
                  <span className="value" style={{ fontWeight: 'bold' }}>
                    {tramite.datos_adicionales?.placa_referencia || '—'}
                  </span>
                </div>
              </div>
            )}
            
            <div className="form-group" style={{ marginTop: '15px' }}>
              <label>Motivo de eliminación <span className="required">*</span></label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Ej. Error en los datos cargados, trámite duplicado..."
                required
                style={{ width: '100%', minHeight: '80px', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
              />
            </div>
            <p className="warning-text" style={{ color: '#d97706', fontWeight: '600', fontSize: '13px', margin: '10px 0 0 0' }}>
              ⚠️ El Tránsito deberá aprobar esta petición para liberar la placa asociada.
            </p>
          </div>

          <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={submitting}
              style={{ padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={submitting || !reason.trim()}
              style={{ padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', backgroundColor: '#ef4444', borderColor: '#ef4444', color: 'white', fontWeight: '600' }}
            >
              {submitting ? '⏳ Enviando...' : '📤 Solicitar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TramiteRequestDeletionModal;
